<template>
  <client-only>
    <pdf
      :src="src"
      :page="page"
    />
  </client-only>
</template>

<script>
export default {
  components: {
    // eslint-disable-next-line consistent-return
    pdf: () => {
      if (process.client) {
        return import('vue-pdf');
      }
    },
  },
  props: {
    src: { type: String, required: true, default: '' },
    page: { type: Number, required: false, default: 1 },
  },
  errorCaptured() {
    return false;
  },
};

</script>
